import React from "react";
import { useTranslation } from 'react-i18next';
import './ScenarioMiniCard.css';

const ScenarioMiniCard = ({ scenario }) => {
  const { t } = useTranslation();

  return (
    <div className="scenario-mini-card">
      <div className="scenario-header">
        <span className="scenario-title">{scenario.title}</span>
        {scenario.type && (
          <span className={`scenario-type-badge type-${scenario.type.toLowerCase()}`}>
            {scenario.type}
          </span>
        )}
        {scenario.positive !== undefined && (
          <span className={`scenario-pos-badge ${scenario.positive ? "positive" : "negative"}`}>
            {scenario.positive ? `✅ ${t('scenarioMiniCard.positive')}` : `❌ ${t('scenarioMiniCard.negative')}`}
          </span>
        )}
      </div>
      <ul className="scenario-steps">
        {scenario.steps?.map((step, idx) => (
          <li key={idx}>
            <span className="gherkin-keyword">{step.type}</span>
            <span className="gherkin-text"> {step.text}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ScenarioMiniCard;